import {
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    ListItemAvatar,
    Badge
} from "@mui/material";
import React, { FC } from "react";
import styled from "@emotion/styled";
import { NavLink } from "react-router-dom";
import { BookmarkIcon, ExploreIcon, HomeIcon } from "icons";
import { useShowEventsDotQuery } from "api";
import { reference } from "../../pages/Home";
import ReactGA from "react-ga4";
import { CLICK_LEARN } from "utills/events";

const MenuList: FC = () => {
    const { data } = useShowEventsDotQuery();

    const handleRefetchFeed = () => {
        (reference?.current as any)?.refetch()
    }
    const learnClick = () => {
        ReactGA.event(CLICK_LEARN, {});

    }

    return (
        <CustomList dense>
            <ListItem disableGutters disablePadding data-tut="reactour__home">
                {location.pathname.includes("/home")
                    ?
                    <ListItemButton disableGutters onClick={handleRefetchFeed}>
                        <ListItemAvatar>
                            <HomeIcon />
                        </ListItemAvatar>
                        <ListItemText primaryTypographyProps={{ variant: "h2" }} primary="Home" />
                    </ListItemButton>
                    :
                    <ListItemButton disableGutters component={NavLink} to="/home" activeClassName="active" data-tut="reactour__home">
                        <ListItemAvatar>
                            <HomeIcon />
                        </ListItemAvatar>
                        <ListItemText primaryTypographyProps={{ variant: "h2" }} primary="Home" />
                    </ListItemButton>
                }
            </ListItem>
            <ListItem disableGutters disablePadding>
                <ListItemButton disableGutters component={NavLink} to="/explore" activeClassName="active" data-tut="reactour__explore">
                    <ListItemAvatar>
                        <ExploreIcon />
                    </ListItemAvatar>
                    <ListItemText primaryTypographyProps={{ variant: "h2" }} primary="Explore" />
                </ListItemButton>
            </ListItem>
            <ListItem disableGutters disablePadding>
                <ListItemButton disableGutters component={NavLink} to="/bookmarks" activeClassName="active">
                    <ListItemAvatar>
                        <BookmarkIcon />
                    </ListItemAvatar>
                    <ListItemText primaryTypographyProps={{ variant: "h2" }} primary="Bookmarks" />
                </ListItemButton>
            </ListItem>
            <ListItem disableGutters disablePadding>
                <ListItemButton disableGutters component={NavLink} to="/learn" onClick={learnClick} activeClassName="active" data-tut="reactour__learn">
                    <ListItemAvatar>
                        <Badge badgeContent={Boolean(data?.showEventsDot) ? <BlueDot /> : null}>
                            <LearnIcon />
                        </Badge>
                    </ListItemAvatar>
                    <ListItemText primaryTypographyProps={{ variant: "h2" }} primary="Learn" />
                </ListItemButton>
            </ListItem>
        </CustomList>
    );
};

const LearnIcon = () => (
    <svg width="24" height="24" viewBox="0 0 408 306" fill="none" xmlns="http://www.w3.org/2000/svg" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M393.121 80.1489L230.291 5.72788C213.575 -1.90929 194.438 -1.90929 177.722 5.72788L14.8793 80.1489C5.69925 84.3563 0 93.243 0 103.354C0 113.464 5.69925 122.351 14.8793 126.558L76.5 154.723V231.923C76.5 259.323 93.5723 283.497 118.996 292.077C146.574 301.321 175.172 306 204 306C232.828 306 261.426 301.321 289.03 292.077C314.428 283.509 331.5 259.335 331.5 231.923V154.723L357 143.069V216.751C357 223.789 362.699 229.501 369.75 229.501C376.801 229.501 382.5 223.789 382.5 216.751V131.416L393.121 126.558C402.301 122.364 408 113.477 408 103.366C408 93.2557 402.301 84.3436 393.121 80.1489ZM306 231.923C306 248.383 295.902 262.842 280.908 267.903C230.979 284.631 176.996 284.618 127.118 267.903C112.098 262.842 102 248.371 102 231.923V166.376L177.709 200.979C186.061 204.792 195.024 206.704 204 206.704C212.976 206.704 221.927 204.804 230.291 200.979L306 166.376V231.923ZM219.67 177.787C209.712 182.339 198.275 182.339 188.318 177.787L25.4108 103.379L25.4872 103.341L188.33 28.9199C198.288 24.3682 209.725 24.3682 219.682 28.9199L382.513 103.366L219.67 177.787Z" fill="currentColor" />
    </svg>

)
export default MenuList;

const BlueDot = styled.div`
    width: 12px;
    height: 12px;
    background: #1DA1F3;
    border: 2px solid #FAFAFA;
    border-radius: 50%;
`;

const CustomList = styled(List)`
    .MuiListItemButton-root {
        padding-left: 24px;
    }
    .MuiListItemAvatar-root {
        min-width: 44px;
        align-items: center;
        display: flex;
        position: relative;
    }
    a:hover {
        color: #007aff;
        .MuiListItemIcon-root{
            color: #007aff;
        }
        .MuiTypography-root {
            color: #007aff;
        }
    }
`;
